import * as Popup from "./components/popup";
import { alertError } from "./dialog";
import { enableVisualLoader, disableVisualLoader } from "./visual_loader";
import { getUITranslation } from "../utils/get_ui_translation";
import { fetch, fetchJSON } from "./api.js";
import { openEmailCustomizer } from "./email_form.js";

// A request stays pending through the automatic reminder: "resent" is "created" plus one reminder email.
export function isPendingSignature(state) {
  return state === "created" || state === "resent";
}

export async function startSignOne(generatedFileId, signature_params) {
  const params = {
    id: generatedFileId,
    signature_params,
  };

  try {
    const response = await fetchJSON(p`/ajax/signing/sign_one`, {
      method: "POST",
      credentials: "same-origin",
      body: JSON.stringify(params),
      headers: {
        "Content-Type": "application/json",
      },
    });
    return await response;
  } catch (_e) {
    return { success: false, reason: "internal error" };
  }
}

/**
 * To allow users to choose which email template should be used we must
 * present the email before the initiation of the signing request
 */
export async function tweakEmail(type) {
  const emailType =
    type === "instructor_cadre_contract" ? "instructor_contract_electronic_signature_invitation" : "electronic_signature_invitation";

  const title = getUITranslation("Prévisualisation de l'e-mail d'invitation");

  return openEmailCustomizer({
    title,
    type: emailType,
    testable: false,
    manageRecipients: false,
  });
}

/**
 * Fetch function to retrieve informations about the signature workflow and form a new modal to be displayed
 **/
export async function onGetSignatureInformations(e) {
  let button = e.currentTarget;
  let generateDocButton = button.closest(".js-alpine-esign-wrapper");
  const parentNode = generateDocButton.querySelector(".js-alpine-esign-gf");
  if (parentNode) {
    enableVisualLoader();
    const generatedFile = JSON.parse(parentNode.getAttribute("data-generated-file"));
    const response = await fetch(p`/ajax/signing/workflow/retrieve/${generatedFile.id}`);
    if (!response.ok) {
      disableVisualLoader();
      alertError(getUITranslation("Oups une erreur"), getUITranslation("Une erreur est survenue, merci de réessayer ultérieurement."));
    } else {
      const value = await response.json();
      let modalNode = document.getElementById("signature-info-card");
      if (!modalNode) {
        modalNode = document.createElement("div");
        modalNode.setAttribute("id", "signature-info-card");
        modalNode.classList.add("signature-info-card");
        document.querySelector("body").appendChild(modalNode);
      }
      modalNode.innerHTML = value.modal_content;
      const popupEl = document.getElementById("modal-signature-info-card");
      disableVisualLoader();
      Popup.open(popupEl);
    }
  } else {
    alertError(getUITranslation("Oups une erreur"), getUITranslation("Une erreur est survenue, merci de réessayer ultérieurement."));
  }
}
